import { ApiVisa, AppletLanguageHdrTenantService, AppletLanguageConatinerHdrModel, Pagination } from 'blg-akaun-ts-lib';
import { Input, Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SubSink } from 'subsink2';

@Component({
    selector: 'default-language-select-drop-down',
    templateUrl: './default-language-select-drop-down.component.html',
    styleUrls: ['./default-language-select-drop-down.component.css'],
  })
export class DefaultLanguageSelectDropDownComponent implements OnInit, OnDestroy {
  @Input() language: FormControl;
  @Input() apiVisa: ApiVisa;
  @Input() controlName: string;

  @Output() languageData = new EventEmitter<string>();

  private subs = new SubSink();

  languageList: AppletLanguageConatinerHdrModel[] = [];
  languageControl: FormControl = new FormControl();
  selectedLanguage;

  constructor(
    private appletLanguageHdrService: AppletLanguageHdrTenantService
  ) {}

  ngOnInit() {
    let condCriteria = [
      { columnName: 'applet_hdr_guid', operator: '=', value: sessionStorage.getItem('appletGuid') }
    ]
    this.appletLanguageHdrService.getByCriteria(new Pagination(0, 100, condCriteria), this.apiVisa).subscribe((res) => {
      this.languageList = res.data;
    });

    if (this.language) {
      this.languageControl = this.language;
    }

    this.subs.sink = this.languageControl.valueChanges.subscribe(value => {
      let selectedLanguage = null;
      selectedLanguage = this.languageList.find(lang => lang.bl_applet_language_hdr.guid === value);
      if (selectedLanguage) {
        this.languageData.emit(selectedLanguage);
      }
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}